module.exports = __webpack_public_path__ + "code-plan.2W9SFO3A.svg";